import React, { useState, useEffect, useContext } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import ConfirmationDialog from "../../../components/Dialog/ConfirmationDialog";
import axios from "axios";
import { json, useNavigate } from "react-router-dom";
import {
  Card,
  CardContent,
  Fab,
  CardHeader,
  FormControl,
  FormHelperText,
  Stack,
  ButtonGroup,
  Box,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialBox from "../../../components/MaterialBox";
import MaterialInput from "../../../components/MaterialInput";
import MaterialButton from "../../../components/MaterialButton";
import BASEURL from "../../Utils/Baseurl";
import MaterialSelect from "../../../components/MasterSelect";
import UserDetailsContext from "../../../context/auth";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { useLoading } from "../../../context/loading";
import Swal from "sweetalert2";
import { ApolloClient, InMemoryCache } from "@apollo/client";
import { createUploadLink } from "apollo-upload-client";
import { gql } from "@apollo/client";
import { Allleaveconfigquery } from "../../LeaveConfiguration/GraphQl";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
// import { FileUpload } from "../../../CrudApi/ApiCalling";

const AddManualLop = () => {
  const { circleLoading, setCirleLoading } = useLoading();
  const [display, setdisplay] = useState(false);
  const [id, setId] = useState(null);
  const [leaveoptions, setleaveoptions] = useState([]);
  const [leavecount, setleavecount] = useState([]);
  const [originalleavedatas, setoriginalleavedatas] = useState(null);
  const [dorOptions, setDorOptions] = useState([]);
  const [resource, setResource] = useState({
    leaveTypeData: [],
  });
  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });
  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });
  const [leaveData, setLeaveData] = useState({
    requestedOn: new Date().toISOString().split("T")[0],
    leaveType: "",
    leaveFrom: "",
    leaveTill: "",
    halfDay: false,
    reason: "",
    primaryDor: "",
    secondaryDor: "",
    followUpTasks: "",
    totalDays: "",
    file: "",

    fileStatus: "unchecked",
    requestedOnStatus: "unchecked",
    leaveTypeStatus: "unchecked",
    leaveFromStatus: "unchecked",
    leaveTillStatus: "unchecked",
    reasonStatus: "unchecked",
    primaryDorStatus: "unchecked",
    secondaryDorStatus: "unchecked",
    followUpTasksStatus: "unchecked",
    totalDaysStatus: "Unchecked",
  });
  const [AllLeave, setAllLeave] = useState([]);
  const [Finalresult, setFinalresult] = useState("");
  const [filename, setfilename] = useState("");
  const navigate = useNavigate();
  const { user, leavedisplay, AccessData, LeaveShow } =
    useContext(UserDetailsContext);
  const alldata = sessionStorage.getItem("user");
  let userdata = JSON.parse(alldata);
  const TeamLeaderId = userdata?.teamleader;

  const uploadLink = createUploadLink({ uri: BASEURL });
  const client = new ApolloClient({
    link: uploadLink,
    cache: new InMemoryCache(),
  });

  const LeaveDetailOptions = [
    { value: "sickLeave", label: "Sick Leave" },
    { value: "casualLeave", label: "Casual Leave" },
    { value: "earnedLeave", label: "Earned Leave" },
    { value: "restrictedLeave", label: "Restricted Leave" },
    { value: "lossofpay", label: "Loss Of Pay" },
  ];

  useEffect(() => {
    if (leaveData.leaveFrom && leaveData.leaveTill) {
      let date1 = new Date(leaveData.leaveFrom);
      let date2 = new Date(leaveData.leaveTill);
      let Difference_In_Time = date2.getTime() - date1.getTime();
      let Days = Math.round(Difference_In_Time / (1000 * 3600 * 24));
      let Total_Days = Days + 1;

      setLeaveData((prev) => ({
        ...prev,
        totalDays: Total_Days,
      }));
    }
  }, [leaveData.leaveFrom, leaveData.leaveTill]);

  useEffect(() => {
    const userId = user?.id;

    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
    setId(id);
    if (id) {
      handleGetLeaves(id);
    }
  }, []);

  useEffect(() => {
    // getleavetype();
    Allleavedata();
    onEmployeeeSubmit();
  }, []);

  useEffect(() => {
    getDor();
  }, []);

  const onCancelAction = () => {
    navigate("/apply-leave");
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      leaveData.leaveTypeStatus === "success" &&
      leaveData.leaveFromStatus === "success" &&
      leaveData.leaveTillStatus === "success" &&
      leaveData.reasonStatus === "success"
      //   leaveData.primaryDorStatus === "success" &&
      //   leaveData.secondaryDorStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const handlefileupload = (e) => {
    const file = e.target.files[0];
    console.log("filefile:", file.name);
    setfilename(file.name);
    setLeaveData({
      ...leaveData,
      file,
      fileStatus: file ? "success" : "error",
    });
  };

  const handleEditData = () => {
    setdisplay(true);
    setTogglePage({
      view: false,
      edit: true,
    });
  };

  //  HANDLE
  const handleLeaveDatachange = (event, selectEvent) => {
    let leaveState = { ...leaveData };
    if (event?.target === undefined && selectEvent) {
      if (event?.target === undefined && selectEvent) {
        const validDropdowns = ["primaryDor", "secondaryDor"];
        if (validDropdowns.includes(selectEvent.name)) {
          const lengthRegex = /^[A-Za-z0-9\s]+$/;
          leaveState[selectEvent.name + "Status"] = lengthRegex.test(
            event?.label
          )
            ? "success"
            : "error";
        }

        leaveState[selectEvent.name] = event;
      }

      if (selectEvent.name === "leaveType") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");

        let dat = event?.mainvalue;
        let alldata = AllLeave.filter((item) => item.name == dat);
        setFinalresult(alldata);

        if (lengthRegex.test(event?.label) === true) {
          leaveState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          leaveState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      leaveState[selectEvent.name] = event;
    } else {
      const changeAllowed = true;
      switch (event.target.name) {
        case "leaveFrom": {
          const selectedDate = new Date(event.target.value);
          selectedDate.setHours(0, 0, 0, 0);

          const today = new Date();
          today.setHours(0, 0, 0, 0);

          const applyBefore = Finalresult[0]?.applyBefore;
          const applyAfter = Finalresult[0]?.applyAfter;

          if (selectedDate > today) {
            // FUTURE leave date → apply BEFORE condition
            const minAllowedDate = new Date(selectedDate);
            minAllowedDate.setDate(minAllowedDate.getDate() - applyBefore);

            if (today < minAllowedDate || today >= selectedDate) {
              alert(
                `You must apply at least ${applyBefore} day(s) before the leave date.\n` +
                  `Valid apply date range: ${minAllowedDate.toDateString()} to ${new Date(
                    selectedDate - 1
                  ).toDateString()}.`
              );
              leaveState[event.target.name + "Status"] = "error";
              leaveState[event.target.name] = "";
            } else {
              leaveState[event.target.name] = event.target.value;
              leaveState[event.target.name + "Status"] = "success";
            }
          } else if (selectedDate < today) {
            // PAST leave date → apply AFTER condition
            const maxApplyDate = new Date(selectedDate);
            maxApplyDate.setDate(maxApplyDate.getDate() + applyAfter);

            if (today <= maxApplyDate) {
              leaveState[event.target.name] = event.target.value;
              leaveState[event.target.name + "Status"] = "success";
            } else {
              alert(
                `You can only apply for this past leave within ${applyAfter} day(s) after the leave date.\n` +
                  `Valid apply date range: ${new Date(
                    selectedDate.getTime() + 1 * 86400000
                  ).toDateString()} to ${maxApplyDate.toDateString()}.`
              );
              leaveState[event.target.name + "Status"] = "error";
              leaveState[event.target.name] = "";
            }
          } else {
            // selected date is today – not allowed
            alert("You cannot apply for leave on the same day.");
            leaveState[event.target.name + "Status"] = "error";
            leaveState[event.target.name] = "";
          }

          break;
        }

        case "leaveTill":
          {
            const dateLengthRegex = new RegExp(
              "^[a-zA-Z0-9 !@#$%^&*()_+{}|:\"<>?`\\[\\]\\\\;,./'-=~]{10,150}$"
            );

            const leaveFrom = new Date(leaveData.leaveFrom);
            const leaveTill = new Date(event.target.value);

            const dayDifference =
              Math.ceil((leaveTill - leaveFrom) / (1000 * 60 * 60 * 24)) + 1;

            console.log("dayDifference:", dayDifference);

            if (dayDifference > Finalresult[0]?.maxConsecutiveDays) {
              alert(
                `You can only apply for a maximum of ${Finalresult[0]?.maxConsecutiveDays} consecutive days.`
              );
              leaveState[event.target.name + "Status"] = "error";
            } else if (dateLengthRegex.test(event.target.value?.trim())) {
              leaveState[event.target.name + "Status"] = "success";
            } else {
              leaveState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "reason":
          {
            const descriptionRegex = new RegExp("^([\\s\\S]{10,100})$");

            if (descriptionRegex.test(event.target.value?.trim())) {
              leaveState[event.target.name + "Status"] = "success";
            } else {
              leaveState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "halfDay":
          {
            leaveState[event.target.name] = event.target.value;
            leaveState[event.target.name + "Status"] = event.target.checked
              ? "success"
              : "unchecked";
          }
          break;
        case "followUpTasks":
          {
            const descriptionRegex = new RegExp("^([\\s\\S]{1,100})$");

            if (descriptionRegex.test(event.target.value?.trim())) {
              leaveState[event.target.name + "Status"] = "success";
            } else {
              leaveState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        default:
          break;
      }
      if (changeAllowed) {
        leaveState[event.target.name] = event.target.value;
      }
    }
    setLeaveData(leaveState);
  };

  const handleAddLeave = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to submit your details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onLeaveRequestSubmit();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  // ONCLCIK
  const AddDelete = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Delete your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onDeleteSubmitLeave();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const handleCancel = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to cancel?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onCancelAction(); // Call the function that handles cancel
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  // QUERIES
  const getleavetype = async () => {
    let query = `query LeaveBalanceByUser($userId: Int!) {
  leaveBalanceByUser(userId: $userId) {
  id
    leaveType
    balanceLeave
    id
    active
  }
}`;

    try {
      const response = await axios.post(
        BASEURL,
        {
          query,
          variables: { userId: user?.id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = response.data.data.leaveBalanceByUser;

      let filterdata = data.filter((val) => val.active == true);

      console.log("hxssbbsd:", filterdata);

      const formattedOptions = filterdata
        .filter((item) => {
          const leaveType = item?.leaveType;

          if (!leaveType || leaveType === "work_from_home") {
            return false;
          }

          if (leaveType === "paternity_leave") {
            return (
              userdata.gender === "Male" &&
              userdata.matural_status === "Married"
            );
          }

          if (leaveType === "maternity_leave") {
            return (
              userdata.gender === "Female" &&
              userdata.matural_status === "Married"
            );
          }
          if (leaveType === "adoption_leave") {
            return userdata.gender === "Female";
          }
          if (leaveType === "surrogacy_leave") {
            return userdata.gender === "Female";
          }

          return true;
        })
        .map((item) => ({
          value: item.id,
          label: item.leaveType.replace(/_/g, " ").toUpperCase(),
          mainvalue: item.leaveType,
        }));

      let resultdata = formattedOptions.filter(
        (val) => val.label != "WORK FROM HOME"
      );

      const temp = [];
      filterdata?.map((item) => {
        const leaveType = item?.leaveType;

        if (leaveType !== "loss_of_pay" && leaveType !== "work_from_home") {
          if (leaveType === "paternity_leave") {
            if (
              userdata.gender === "Male" &&
              userdata.matural_status === "Married"
            ) {
              temp.push(item);
            }
          } else if (leaveType === "maternity_leave") {
            if (
              userdata.gender === "Female" &&
              userdata.matural_status === "Married"
            ) {
              temp.push(item);
            }
          } else if (leaveType === "adoption_leave") {
            if (userdata.gender === "Female") {
              temp.push(item);
            }
          } else if (leaveType === "surrogacy_leave") {
            if (userdata.gender === "Female") {
              temp.push(item);
            }
          } else {
            temp.push(item);
          }
        }
      });

      const formatted = temp.map((item) => ({
        count: item.balanceLeave,
        leavetype: item.leaveType,
        id: item.leaveType?.id,
      }));

      console.log("formattedOptions:", formattedOptions);

      setleavecount(formatted);
      setleaveoptions(formattedOptions);
    } catch (error) {
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message: error.message,
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const onEmployeeeSubmit = async () => {
    const query = `query{
          allUsersDetail{
          id
          lastLogin
          username
          firstName
          lastName
          isActive
          dateJoined
          email
          salutation
          dateOfBirth
          contactNumber
          emergencyContact
          gender
          employeeType
          lastUpdate
          department
          designation
          empid
          teamleader 
          grade
          role{
          role
          }
          }}`;

    try {
      setPageState({ ...pageState, loading: true });

      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      //   const userDetails = sessionStorage.getItem('user')
      //   const getDetails = JSON.parse(userDetails)
      //   setUserDetails({
      //       department: user?.department || getDetails.department || "",
      //       designation: user?.designation || getDetails.designation || "",
      //       employeeType: user?.employeeType || getDetails.employeeType || ""
      //   })

      // Extract Employee data from the response
      const EmpList = response.data.data.allUsersDetail;
      console.log("EmpList:", EmpList);

      let filterdata = EmpList.filter((val) => val.empid != "").map((emp) => ({
        value: emp?.id,
        label: emp?.firstName,
      }));
      console.log("filterdata:", filterdata);

      setleaveoptions(filterdata);
      setPageState({ ...pageState, loading: false, state: "success" });
    } catch (error) {
      console.error("ResponseError:", error);
      setPageState({
        ...pageState,
        loading: false,
        error: true,
        message: error.message,
      });
    }
  };

  const Allleavedata = async () => {
    try {
      setPageState({ ...pageState, loading: true });

      const response = await axios.post(
        BASEURL,
        {
          query: Allleaveconfigquery,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = response.data.data.allLeaveConfigurations;
      console.log("Datadata:", data);

      setAllLeave(data);
    } catch (error) {
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message: error.message,
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const getDor = async () => {
    const department = sessionStorage.getItem("user");
    const empId = JSON.parse(sessionStorage.getItem("user"));
    const deapartmentData = JSON.parse(department);

    const query = `
   query GetEmployees($department: String!, $id: String!) {  
    getEmployeesByDepartment(department: $department, id: $id) {  
      id  
      username  
      firstName
      lastName
      department  
    }  
  } 
    `;
    try {
      const response = await axios.post(
        BASEURL,
        {
          query,
          variables: {
            department: deapartmentData.department,
            id: empId.id,
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data?.data?.getEmployeesByDepartment) {
        const formattedDorOptions =
          response.data.data.getEmployeesByDepartment.map((item) => ({
            value: item.id,
            label: item.firstName,
          }));

        setDorOptions(formattedDorOptions);
      }
    } catch (error) {
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message: error.message,
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  // CREATE
  const onLeaveRequestSubmit = async () => {
    setCirleLoading(true);
    const query = gql`
      mutation ManualLop($input: LeaveApplicationInput!) {
        ManualLop(input: $input) {
          leaveApproval {
            id

            user {
              empid

              firstName

              lastName
            }

            leaveType {
              id

              name
            }

            leaveFrom

            leaveTill

            totalDays

            halfDay

            reason

            requestedOn

            status
          }

          success

          message
        }
      }
    `;

    let variables = {
      input: {
        // userId: userdata.id,
        // teamleaderId: TeamLeaderId || null,
        requestedOn: leaveData.requestedOn || null,
        employeeId: leaveData.leaveType?.value || "",
        leaveFrom: leaveData.leaveFrom || null,
        leaveTill: leaveData.leaveTill,
        // totalDays: leaveData.totalDays || null,
        halfDay: leaveData.halfDay || "",
        reason: leaveData.reason || null,
        // primaryDor: leaveData.primaryDor?.value || null,
        // secondaryDor: leaveData.secondaryDor?.value || null,
        // followUpTasks: leaveData.followUpTasks || "",
        // screenName: "Leave Approval",
        // attachment: leaveData.file,
      },
    };

    try {
      const response = await client.mutate({
        mutation: query,
        variables: variables,
      });

      console.log("res:", response);
      let Val = response?.data?.ManualLop?.success;
      let  message = response?.data?.ManualLop?.message
      if (Val) {
   
          Swal.fire({
            position: "center",
            icon: "success",
            title: message,
            showConfirmButton: false,
            timer: 2500,
          });
          navigate("/manual-lop");
        
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        setCirleLoading(false);
    }
    //   } else if (response?.data?.errors && response.data.errors.length > 0) {
    //     if (
    //       response.data.errors[0]?.message ===
    //       "You already have a pending or approved leave/work-from-home request for the selected dates."
    //     ) {
    //       Swal.fire({
    //         position: "center",
    //         icon: "error",
    //         title: response.data.errors[0]?.message,
    //         showConfirmButton: false,
    //         timer: 5500,
    //       });
    //     }
    //     setConfirmationDialog({
    //       ...confirmationDialog,
    //       open: false,
    //     });
    //     setCirleLoading(false);
    //   } 
    // 
    else {
        console.error("Unexpected response structure:", response);
        Swal.fire({
          position: "center",
          icon: "error",
          title: message,
          showConfirmButton: false,
          timer: 3000,
        });
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        setCirleLoading(false);
      }
    } catch (error) {
      console.error("responseError:", error);
      setCirleLoading(false);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message: error.message,
        showCancel: true,
        showConfirm: false,
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  // EDIT
  const LeaveEditRequest = async () => {
    setCirleLoading(true);
    const query = `
    mutation UpdateLeaveRequest($id: String!, $input: UpdateLeaveRequestInput!) { 
    UpdateLeaveRequest(id: $id, input: $input) { 
      updateLeave { 
        id 
        requestedOn 
        leaveType { 
          id 
        } 
        leaveFrom 
        leaveTill 
        totalDays 
        halfDay 
        reason 
        primaryDor { 
          username 
        } 
        secondaryDor { 
          username 
        } 
        followUpTasks 
        teamApproval 
        hrApproval 
        status 
        lastUpdate 
        teamleaderId 
      } 
    } 
  }  `;

    const fileterdata = leaveoptions.filter(
      (val) => val.label === leaveData.leaveType.label
    );

    const variables = {
      id: id,
      input: {
        leaveFrom: leaveData.leaveFrom,
        leaveTill: leaveData.leaveTill,
        teamleaderId: TeamLeaderId,
        leaveType: fileterdata[0]?.value,
        totalDays: leaveData.totalDays,
        halfDay: leaveData.halfDay || false,
        reason: leaveData.reason || "",
        primaryDor: leaveData.primaryDor?.username,
        secondaryDor: leaveData.secondaryDor?.username,
        followUpTasks: leaveData.followUpTasks,
      },
    };

    try {
      const response = await axios({
        url: BASEURL,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          query,
          variables,
        }),
      });

      let result = response.data.data.UpdateLeaveRequest?.updateLeave;

      if (result !== null) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Leave Updated  Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/apply-leave");
      }

      setCirleLoading(false);
    } catch (error) {
      setCirleLoading(false);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message: error.message,
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  // BY ID
  const handleGetLeaves = async (id) => {
    const query = `
    query GetLeaveById($id: String!) {
 
  getLeaveById(id: $id) {
 
    data {
 
      id
 
      reason
 
      totalDays 
      user{
        id
        firstName
        lastName
      }
      status
      teamApproval
      hrApproval
      teamleaderId
      leaveType{
        id
        name
      }

 
      primaryDor{
 
        firstName
        lastName
 
      }
 
 
      secondaryDor{
 
        firstName
        lastName
 
      } 
      attachment
      approvalStatus{
        id
        approver{
          id
          firstName
          lastName
        }
      }
 
 
      followUpTasks
 
    }
 
    success
 
    error
 
    message
 
  }
 
}
            `;

    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: { id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = response.data;

      if (response.data.errors) {
        console.error("GraphQL Errors:", response.data.errors);
        return;
      }

      const leaveDatass = data.data.getLeaveById?.data[0];
      const fileterdata = leaveoptions.filter(
        (val) => val.label === leaveDatass.leaveType.leaveType
      );

      const selectedLeaveType =
        LeaveDetailOptions.find(
          (opt) => opt.value === leaveDatass.leaveType.leaveType
        ) || "";

      setLeaveData({
        ...leaveData,
        leaveType: {
          id: leaveDatass.leaveType.id,
          value: leaveDatass.leaveType.name.replace(/_/g, " ").toUpperCase(),
          label: leaveDatass.leaveType.name.replace(/_/g, " ").toUpperCase(),
        },
        requestedOn: leaveDatass?.requestedOn,
        leaveFrom: leaveDatass?.leaveFrom,
        leaveTill: leaveDatass?.leaveTill,
        reason: leaveDatass?.reason,
        primaryDor: leaveDatass?.primaryDor?.username,
        secondaryDor: leaveDatass?.secondaryDor?.username,
        followUpTasks: leaveDatass?.followUpTasks,
        halfDay: leaveDatass?.halfDay,
      });
      setoriginalleavedatas({
        ...leaveDatass,
        leaveType: {
          value: leaveDatass.leaveType.leaveType,
          label: leaveDatass.leaveType.leaveType,
        },
      });
      setTogglePage({
        ...togglePage,
        view: true,
      });
    } catch (error) {
      console.log("ResponseError:", error.message);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message: error.message,
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  // DELETE
  const onDeleteSubmitLeave = async () => {
    setCirleLoading(true);
    const query = `
       mutation delete($id:String!){
  DeleteLeaveRequest(id:$id){
        success
  }
}
    `;

    try {
      const response = await axios.post(BASEURL, {
        query: query,
        variables: {
          id: id,
        },
      });

      if (response.data.data.DeleteLeaveRequest.success) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Leave Deleted Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/apply-leave");
      } else {
        console.log(
          "Error deleting Holiday:",
          response.data.data.deleteHoliday.message
        );
      }
      setCirleLoading(false);
    } catch (error) {
      setCirleLoading(false);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message: error.message,
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      <Grid container>
        {leavecount.map((wfh, index) => (
          <Grid size={{ xs: 12, sm: 3 }} p={1} key={index + 1}>
            <Card>
              <MaterialBox m={4}>
                <MaterialBox
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Fab
                    color="#DFF2EB"
                    sx={{
                      backgroundColor: "#DFF2EB",
                    }}
                  >
                    {wfh.count}
                  </Fab>
                </MaterialBox>

                <MaterialBox
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    paddingY: 1,
                    borderRadius: "100px",
                    backgroundColor: "#f9f9f9",
                    marginTop: "5%",
                  }}
                >
                  <MaterialTypography
                    component="label"
                    variant="body2"
                    fontWeight="bold"
                    sx={{
                      fontSize: "13px",
                      color: "#333333",
                    }}
                  >
                    {wfh.leavetype?.replace(/_/g, " ").toUpperCase()}
                  </MaterialTypography>
                </MaterialBox>
              </MaterialBox>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
              padding={1}
            >
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={60}
              >
                {togglePage.view === true || togglePage.edit === true ? (
                  <MaterialTypography variant="h5" fontWeight="medium">
                    {togglePage.view
                      ? "View Leave Request "
                      : "Edit Leave Request "}
                  </MaterialTypography>
                ) : (
                  <MaterialTypography variant="h5" fontWeight="medium">
                    Add Manual Lop
                  </MaterialTypography>
                )}
                <ButtonGroup
                  variant="outlined"
                  aria-label="Loading button group"
                >
                  {AccessData &&
                    Array.isArray(AccessData) &&
                    AccessData.some(
                      (item) =>
                        item.component === "EditLeave" && item.can_access
                    ) &&
                    leavedisplay && (
                      <>
                        <ButtonGroup
                          variant="outlined"
                          aria-label="Loading button group"
                        >
                          <MaterialButton
                            variant="gradient"
                            color="dark"
                            onClick={handleEditData}
                            startIcon={<EditIcon />}
                          >
                            Edit
                          </MaterialButton>

                          <MaterialButton
                            variant="gradient"
                            color="dark"
                            onClick={AddDelete}
                            startIcon={<DeleteIcon />}
                          >
                            Delete
                          </MaterialButton>
                        </ButtonGroup>
                      </>
                    )}
                </ButtonGroup>
              </Stack>
            </Stack>
          }
        />
        <CardContent sx={{ minHeight: "70vh" }}>
          <MaterialBox>
            <Grid container spacing={1}>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Requested Date
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="requestedOn"
                  value={leaveData.requestedOn}
                  onChange={handleLeaveDatachange}
                  error={leaveData.requestedOnStatus === "error"}
                  success={leaveData.requestedOnStatus === "success"}
                  readOnly
                />
              </Grid>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Employee <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="leaveType"
                  filter
                  value={leaveData.leaveType}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleLeaveDatachange}
                  options={leaveoptions}
                  error={leaveData.leaveTypeStatus === "error" ? true : false}
                  success={
                    leaveData.leaveTypeStatus === "success" ? true : false
                  }
                  isDisabled={togglePage.view === true ? true : false}
                  isClearable
                />
              </Grid>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Leave From <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="leaveFrom"
                  type="date"
                  value={leaveData.leaveFrom}
                  onChange={handleLeaveDatachange}
                  error={leaveData.leaveFromStatus === "error" ? true : false}
                  success={
                    leaveData.leaveFromStatus === "success" ? true : false
                  }
                  disabled={togglePage.view === true ? true : false}
                />
              </Grid>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Leave Till <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="leaveTill"
                  type="date"
                  inputProps={{
                    min: leaveData.leaveFrom,
                  }}
                  value={leaveData.leaveTill}
                  onChange={handleLeaveDatachange}
                  error={leaveData.leaveTillStatus === "error" ? true : false}
                  success={
                    leaveData.leaveTillStatus === "success" ? true : false
                  }
                  disabled={togglePage.view === true ? true : false}
                />
              </Grid>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Total Days
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="reason"
                  placeholder="Auto generated"
                  value={leaveData.totalDays}
                  onChange={handleLeaveDatachange}
                  disabled
                />
              </Grid>

              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Leave Type
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="reason"
                  placeholder="Auto generated"
                  value={"Loss of Pay"}
                  //   onChange={handleLeaveDatachange}
                  disabled
                />
              </Grid>
              {Finalresult[0]?.halfDayAllowed && (
                <Grid container alignItems="center" sx={{ marginLeft: "1%" }}>
                  <MaterialBox
                    lineHeight={0}
                    display="inline-block"
                    sx={{ marginRight: "8px" }}
                  >
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Half Days
                    </MaterialTypography>
                  </MaterialBox>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={leaveData.halfDay}
                        onChange={(e) =>
                          handleLeaveDatachange({
                            target: {
                              name: "halfDay",
                              value: e.target.checked,
                            },
                          })
                        }
                        color="primary"
                      />
                    }
                    label={
                      <MaterialTypography variant="caption" fontWeight="bold">
                        {leaveData.halfDay ? "Yes" : "No"}
                      </MaterialTypography>
                    }
                    sx={{ marginLeft: 0 }}
                    disabled={togglePage.view}
                  />
                </Grid>
              )}

              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Reason <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="reason"
                  multiline
                  rows={4}
                  value={leaveData.reason}
                  onChange={handleLeaveDatachange}
                  error={leaveData.reasonStatus === "error"}
                  success={leaveData.reasonStatus === "success"}
                  disabled={togglePage.view === true ? true : false}
                />
                {leaveData.reasonStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Reason should be a minimum 10 characters & maximum 100
                      characters long.
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              {Finalresult[0]?.attachmentMandatory && (
                <Grid
                  mt={Finalresult[0]?.halfDayAllowed == false ? -8 : 0}
                  size={{ xs: 5, sm: 4 }}
                >
                  <MaterialBox lineHeight={0} display="inline-block" mb={1}>
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Upload the Document{" "}
                      <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>

                  <Box
                    component="label"
                    htmlFor="upload-file"
                    sx={{
                      border: "2px dashed #90caf9",
                      borderRadius: "12px",
                      padding: "21px 43px",
                      width: "100%",
                      minHeight: "100px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      textAlign: "center",
                      backgroundColor: "#f5faff",
                      cursor: "pointer",
                      "&:hover": {
                        backgroundColor: "#e3f2fd",
                      },
                    }}
                  >
                    <CloudUploadIcon sx={{ fontSize: 50, color: "#2196f3" }} />
                    <Typography
                      sx={{ mt: 1, color: "#2196f3", fontWeight: 500 }}
                    >
                      Browse file to upload
                    </Typography>
                    <input
                      hidden
                      id="upload-file"
                      type="file"
                      accept=".pdf,.jpg,.jpeg,.png"
                      onChange={handlefileupload}
                    />
                  </Box>

                  {leaveData?.fileStatus === "error" && (
                    <FormControl error>
                      <FormHelperText>
                        Please upload a valid document (PDF, JPG, PNG).
                      </FormHelperText>
                    </FormControl>
                  )}

                  <FormHelperText>{filename}</FormHelperText>
                </Grid>
              )}
            </Grid>

            {/* <MaterialTypography
              sx={{ mt: 2, mb: 1, color: "rgba(63, 81, 181, 0.83)" }}
              variant="h5"
              fontWeight="bold"
            >
              DOR <span style={{ color: "red" }}>*</span>
            </MaterialTypography>

            <Grid container spacing={1}>
              <Grid size={{ xs: 3, sm: 3 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Primary DOR <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="primaryDor"
                  value={leaveData.primaryDor}
                  options={dorOptions}
                  onChange={handleLeaveDatachange}
                  success={
                    leaveData.primaryDorStatus === "success" ? true : false
                  }
                  error={leaveData.primaryDorStatus === "error" ? true : false}
                />
              </Grid>
              <Grid size={{ xs: 3, sm: 3 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Secondary DOR <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="secondaryDor"
                  value={leaveData.secondaryDor}
                  options={dorOptions}
                  onChange={handleLeaveDatachange}
                  success={
                    leaveData.secondaryDorStatus === "success" ? true : false
                  }
                  error={
                    leaveData.secondaryDorStatus === "error" ? true : false
                  }
                />
              </Grid>
              <Grid size={{ sx: 6, sm: 6 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Follow up Tasks
                  </MaterialTypography>
                  <MaterialInput
                    name="followUpTasks"
                    value={leaveData.followUpTasks}
                    multiline
                    rows={7}
                    onChange={handleLeaveDatachange}
                    error={leaveData.followUpTasksStatus === "error"}
                    success={leaveData.followUpTasksStatus === "success"}
                    disabled={togglePage.view === true ? true : false}
                  />
                </MaterialBox>
              </Grid>
            </Grid> */}
          </MaterialBox>
        </CardContent>
        <MaterialBox
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
        >
          {!leavedisplay && (
            <>
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                onClick={handleCancel}
              >
                Cancel
              </MaterialButton>
              <MaterialButton
                sx={{ m: 2, marginLeft: "4px" }}
                variant="gradient"
                color="dark"
                disabled={!checkAllFields()}
                onClick={handleAddLeave}
              >
                Submit
              </MaterialButton>
            </>
          )}

          {display && (
            <>
              <MaterialButton
                variant="gradient"
                color="dark"
                onClick={handleCancel}
              >
                Cancel
              </MaterialButton>
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                onClick={LeaveEditRequest}
              >
                Update
              </MaterialButton>
            </>
          )}
        </MaterialBox>
      </Card>
    </DashboardLayout>
  );
};
export default AddManualLop;
